<template>
    <div class="popup" v-if="isShowStarPopup">
        <div class="content" id="userStar" :data-language="$i18n.locale">
            <div id="starClose">
                <div class="icon-star-close" @click="closeStarPopup()"></div>
            </div>
            <div id="starTitle">{{$t('language.popup.userStarPopup.starDesc')}}</div>
            <div id="starBox">
                <div v-for="count in 5" :key="count" @click="selectStar(count)" class="icon-star" :class="starData[count-1]?'icon-stared':''"></div>
            </div>
            <button id="starBtn" @click="okStarPopup()">{{$t('language.popup.userStarPopup.ok')}}</button>
        </div>
        <img height="0" width="0" src="../../../assets/images/userStar/thank-you.svg">
    </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data() {
        return {
            // 是否显示弹窗
            isShowStarPopup: false,
            // 星星的选择情况
            starData: [false,false,false,false,false]
        }
    },
    methods: {
        // 关闭
        closeStarPopup() {
            this.isShowStarPopup = false;
        },
        // 选择星星
        selectStar(count) {
            var data = [];
            for (var i=0; i<5; i++) {
                if (i+1 <= count) {
                    data[i] = true;
                }else {
                    data[i] = false;
                }
            }
            this.starData = data;
        },
        // 确定
        okStarPopup() {
            var count = 0;
            for (var i=0; i<5; i++) {
                if (this.starData[i]) {
                    count++;
                }
            }
            if (count >= 4) {
                // 好评
                this.isShowStarPopup = false;
                this.$parent.$refs.userStarJumpPopup.isShowStarJumpPopup = true;
                taskListUtils.userStarUpdateRequest({createReason:1,score:count});
            } else if(count >= 1) {
                // 差评
                this.isShowStarPopup = false;
                this.$parent.$refs.userStarFeedbackPopup.isShowStarFeedbackPopup = true;
                taskListUtils.userStarUpdateRequest({createReason:1,score:count});
            } else {
                // 未选择，不管
            }
        }
    }
}
</script>

<style>
#userStar {
     width: 400px;
     height: 260px;
     border-radius: 16px;
     text-align: center;
     border: 1px solid #FFF;
     font-family: "Segoe UI", "Arial", "Microsoft YaHei", "微软雅黑";
}
/* 多语言特殊处理 */
#userStar[data-language=english], 
#userStar[data-language=chinese], 
#userStar[data-language=traditionalChinese] {
    height: 235px;
}
/* 关闭 */
#starClose {
    position: absolute;
    z-index: 1;
    right: 8px;
    top: 8px;
}
#starClose>.icon-star-close {
    width: 40px;
    height: 40px;
    display: inline-block;
    background-image: url("../../../assets/images/userStar/icon-close.svg");
    background-position: 0px 0px;
    cursor: pointer;
}
#starClose>.icon-star-close:hover {
    background-image: url("../../../assets/images/userStar/icon-close-hover.svg");
}
#starClose>.icon-star-close:active {
    opacity: 0.8;
}
/* 标题 */
#starTitle {
    width: 290px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: bolder;
    word-break: break-all;
    line-height: 24px;
    margin-top: 40px;
}
/* 星星 */
#starBox {
    margin: 25px 0;
}
#starBox>.icon-star {
    width: 40px;
    height: 40px;
    margin: 0 5px;
    display: inline-block;
    background-image: url("../../../assets/images/userStar/icon-star.svg");
    background-position: 0px 0px;
    cursor: pointer;
}
#starBox>.icon-stared {
    background-image: url("../../../assets/images/userStar/icon-star-select.svg");
}
/* 按钮 */
#starBtn {
    font-family: "Segoe UI", "Arial", "Microsoft YaHei", "微软雅黑";
    padding: 6px 68px !important;
    border-radius: 4px;
    font-size: 16px;
    height: 36px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/user_star_popup.vue